import { Controller } from "@hotwired/stimulus"
import { replayAnimation } from "../lib/motion"

// Listing step 7: the publish button reads 請先勾選刊登者聲明 until the lister declaration is ticked, then its label
// slides to 刊登房屋. A tap while locked doesn't submit — it brings the declaration into view and nudges it.
// The server still validates legal_disclaimer_accepted.
export default class extends Controller {
  static targets = ["checkbox", "button", "consent"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasButtonTarget) return
    const ready = this.hasCheckboxTarget && this.checkboxTarget.checked
    this.buttonTarget.classList.toggle("is-ready", ready)
    this.buttonTarget.setAttribute("aria-disabled", String(!ready))
    // Both labels stay in the DOM for the slide; only the visible one names the button.
    this.buttonTarget.querySelector(".publish-gate-label--locked")?.setAttribute("aria-hidden", String(ready))
    this.buttonTarget.querySelector(".publish-gate-label--ready")?.setAttribute("aria-hidden", String(!ready))
  }

  guard(event) {
    if (!this.hasCheckboxTarget || this.checkboxTarget.checked) return
    event.preventDefault()
    if (this.hasConsentTarget) {
      this.consentTarget.scrollIntoView({ behavior: "smooth", block: "center" })
      replayAnimation(this.consentTarget, "publish-gate-nudge")
      this.consentTarget.addEventListener("animationend", () => this.consentTarget.classList.remove("publish-gate-nudge"), { once: true })
    }
    this.checkboxTarget.focus({ preventScroll: true })
  }
}
